// @material-ui/icons components
import AddIcon from '@material-ui/icons/Add';
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import BusinessIcon from '@material-ui/icons/Business';
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import DnsIcon from "@material-ui/icons/Dns";
import EventNoteIcon from "@material-ui/icons/EventNote";
import GroupIcon from "@material-ui/icons/Group";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from '@material-ui/icons/Settings';
import FindReplaceIcon from '@material-ui/icons/FindReplace';
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import FingerprintIcon from '@material-ui/icons/Fingerprint';

// Sidebar에서 사용하는 아이콘 정의
export default {
    Add: AddIcon,
    AccountBox: AccountBoxIcon,
    AlternateEmail: AlternateEmailIcon,
    Business: BusinessIcon,
    BusinessCenter: BusinessCenterIcon,
    Dns: DnsIcon,
    EventNote: EventNoteIcon,
    Group: GroupIcon,
    Person: PersonIcon,
    Settings: SettingsIcon,
    FindReplace: FindReplaceIcon,
    AccountTree: AccountTreeIcon,
    Fingerprint: FingerprintIcon,
};
